import { create } from "zustand";
export const usePostHogStore = create((set, get) => ({
    isReady: false,
    setIsReady: (isReady) => set(() => ({ isReady })),
}));
